import React from "react";
import { Link } from "react-router-dom";
import styles from "./LegalPage.module.css";

// Impressum (legal notice) at /impressum, linked from the site footer.
// Text in [square brackets] is a placeholder — replace with the operator's
// real details before going live.
export default function Impressum() {
  return (
    <main className={styles.page}>
      <Link to="/" className={styles.back}>
        ← Zurück zur Karte
      </Link>

      <h1 className={styles.title}>Impressum</h1>

      <section className={styles.section}>
        <p>
          Kurverwaltung Mönchgut
          <br />
          Eigenbetrieb der Gemeinde Mönchgut
          <br />
          Dorfstraße 4
          <br />
          18586 Ostseebad Mönchgut
        </p>
      </section>

      <section className={styles.section}>
        <h2>Verantwortlich</h2>
        <p>
          Leitung Kurverwaltung Mönchgut
          <br />
          Tourismusmanagerin Frau Franziska Gustävel
        </p>
      </section>

      <section className={styles.section}>
        <h2>Kontakt</h2>
        <p>
          Telefon: 038308 66010
          <br />
          E-Mail: info@ostseebad-moenchgut.de
        </p>
      </section>

      <section className={styles.section}>
        <h2>Umsatzsteuer-ID</h2>
        <p>
          DE 315 829 647
        </p>
      </section>

      <section className={styles.section}>
        <h2>Redaktionell verantwortlich</h2>
        <p>
          <a href="https://wegeleitsystem.com/" target="_blank" rel="noopener noreferrer">
            Wayfinding Expert GmbH
          </a>
          <br />
          Pestalozzistraße 25
          <br />
          22305 Hamburg
        </p>
      </section>

      <section className={styles.section}>
        <h2>Digitale Lösung</h2>
        <p>
          <a href="https://wegeleitsystem.com/" target="_blank" rel="noopener noreferrer">
            Wayfinding Expert GmbH
          </a>
          <br />
          Pestalozzistraße 25
          <br />
          22305 Hamburg
          <br />
          info@wegeleitsystem.com
        </p>
      </section>

      <section className={styles.section}>
        <h2>Kartendaten</h2>
        <p>
          © OpenStreetMap-Mitwirkende, verfügbar unter der{" "}
          <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">
            Open Database License (ODbL)
          </a>  teilweise auf Basis von Shapefiles der Geofabrik
          .
        </p>
      </section>

      <section className={styles.section}>
        <h2>Hinweise zu Urheber- und Nutzungsrechten</h2>
        <ul className={styles.list}>
          <li> Diese interaktive Karte ist ein touristisches Angebot der Kurverwaltung Mönchgut. Die Rechte an der Karte und den von der Kurverwaltung bereitgestellten Inhalten liegen, soweit nicht anders angegeben, bei der Kurverwaltung Mönchgut bzw. bei den jeweils genannten Rechteinhabern.</li>
          <li> Die in der Karte verwendeten Bilder und sonstigen Inhalte stammen teilweise von der Website der Kurverwaltung Mönchgut (www.ostseebad-moenchgut.de) sowie von den jeweils angegebenen Urheberinnen und Urhebern.</li>
          <li> Eine Vervielfältigung, Bearbeitung, Verbreitung oder sonstige Nutzung der Inhalte, insbesondere von Karten, Texten, Textteilen und Bildmaterial, ist nur zulässig, soweit hierfür eine gesetzliche Erlaubnis besteht oder die erforderlichen Nutzungsrechte bzw. Zustimmungen der jeweiligen Rechteinhaber vorliegen.</li>
        </ul>
      </section>
    </main>
  );
}
